import {
    faEye,
    faHourglass,
    faUnlock,
    faWarning,
} from "@fortawesome/pro-regular-svg-icons";
import { faBadgeCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from 'react';
import { MEDIA_LOCKED_LABEL } from '../../../../../hooks/useMediaLocked';
import "./AdvancedMediaViewerLocked.scss";
import Drawer from "../../../Drawer/Drawer";
import AdvancedMediaViewerOptions from '../AdvancedMediaViewerOptions/AdvancedMediaViewerOptions';

const AdvancedMediaViewerLocked = ({media, lockedReason, handleLockedAction, 
    setToggleSlider,
    handleClose})=>{    
    const [toggleActions, setToggleActions] = useState(false);
    const handleToggleActions = useCallback(() =>{
        setToggleSlider(true);
        setToggleActions(!toggleActions);
    }, [toggleActions, setToggleSlider, setToggleActions]);
    const labels = {
        [MEDIA_LOCKED_LABEL.BIG_PLAN] : 'Voir contenu sensible',
        [MEDIA_LOCKED_LABEL.FRIENDS] : 'Réservé à son cercle',
        [MEDIA_LOCKED_LABEL.CERTIFIED] : 'Exclusif aux certifiés',
        [MEDIA_LOCKED_LABEL.MEMBERS_ONLY] : 'Exclusif aux connectés',
        [MEDIA_LOCKED_LABEL.INVISIBLE] : 'Bloqué',
        [MEDIA_LOCKED_LABEL.VIDEO_NOT_READY] : 'La vidéo n\'est pas encore prête',
        [MEDIA_LOCKED_LABEL.VIDEO_ERROR_STATE] : 'Erreur d\'encodage de la vidéo'
    }
    const renderContent = ()=>{
        if ([MEDIA_LOCKED_LABEL.FRIENDS, MEDIA_LOCKED_LABEL.MEMBERS_ONLY].includes(lockedReason)) {
            return (
                <>
                    {labels[lockedReason]}
                    <div className="amv-media-locked-cta">
                        <FontAwesomeIcon icon={faUnlock} /> Rejoindre
                    </div>
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.BIG_PLAN){
            return (
                <>
                    <div className="amv-media-locked-cta">
                        <FontAwesomeIcon icon={faEye} /> {labels[lockedReason]}
                    </div>
                    
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.CERTIFIED){
            return (
                <>
                    {labels[lockedReason]}
                    <div className="amv-media-locked-cta">
                        <FontAwesomeIcon icon={faBadgeCheck} /> Me certifier
                    </div>
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.VIDEO_ERROR_STATE){
            return (
                <>
                    {labels[lockedReason]}
                    <div className="amv-media-locked-cta" onClick={()=>setToggleActions(true)}>
                        Options de la publication
                    </div>
                    <Drawer
                        open={toggleActions}
                        handleClose={handleToggleActions}
                        headContent="Options de la publication"
                        xsmall
                    >
                        <AdvancedMediaViewerOptions media={media} handleClose={handleClose} onlyRemove/>
                    </Drawer>
                </>
            )
        }
        else if(lockedReason === MEDIA_LOCKED_LABEL.VIDEO_NOT_READY){
            return (
                <>
                    <div className="amv-media-locked-icon">
                        <FontAwesomeIcon icon={faHourglass} />
                    </div>
                    {labels[lockedReason]}
                </>
            )
        }
        else {
            return (
                <>
                    <div className="amv-media-locked-icon">
                        <FontAwesomeIcon icon={faWarning} />
                    </div>
                    {labels[lockedReason]}
                </>
            )
        }
    }

    return (
        <div className={`amv-media-locked plausible-event-name=LOCKED_PLAYER_${lockedReason}`} onClick={handleLockedAction}>
            {renderContent()}
        </div>
    )
}

export default React.memo(AdvancedMediaViewerLocked);